import { DisclosureScreenState } from './DisclosureTypes';
import { Disclosure } from '../../../types';

export const DisclosureActionTypes = {
  LOADING_DISCLOSURES: 'loadingDisclosureList',
  FAILED_DISCLOSURES: 'loadFailureDisclosureList',
  LOADED_DISCLOSURES: 'loadedDisclosureList',

  NEW_DISCLOSURE: 'createNewDisclosure',
  EDIT_DISCLOSURE: 'editDisclosure',
  SAVE_DISCLOSURE: 'saveDisclosure',
  SAVING_DISCLOSURE: 'savingDisclosure',
  SAVING_DISCLOSURE_FAILED: 'savingDisclosureFailed',

  CANCEL_DISCLOSURE_FORM: 'cancelDisclosureForm',
  RESET_DISCLOSURE_FORM: 'resetDisclosureForm',
  FORM_FIELDS_UPDATED: 'formFieldUpdate',
  SEARCH_STRING_UPDATED: 'searchStringFilter',
  LOADED_ACL_DATA: 'loadedAclData',

  PAGE_SWITCH: 'disclosurePageStateSwitch',

  LOADING_HISTORY_DATA: 'disclosureHistoryLoading',
  FAILED_HISTORY_DATA: 'disclosureHistoryFailed',
  LOADED_HISTORY_DATA: 'disclosureHistoryLoaded',
  HISTORY_FILTER_UPDATED: 'disclosureHistoryFilterUpdated',
};

export const PAGE_STATE = {
  LIST: 'list',
  HISTORY: 'hitory',
};

export const FORM_STATE = {
  CLOSE: 'close',
  OPEN: 'open',
  LOCKED: 'locked',
  DISABLED: 'disabled',
  VALIDATING: 'validating',
  FAILED_SUBMIT: 'failed',
};

export const BLANK_DISCLOSURE: Disclosure = {
  DisclosureId: 0,
  DisclosureName: '',
  DisclosureContent: '',
  DisclosureVertical: '',
  IsActive: false,
  IsDba: false,
  IsDefault: false,
};

export const DEFAULT_STATE: DisclosureScreenState = {
  loadStatus: 0,
  disclosures: {},
  filtered: [],
  search: '',
  formState: FORM_STATE.CLOSE,
  pageState: PAGE_STATE.LIST,
  admin: false,
  currentDisclosure: {
    form: {
      ...BLANK_DISCLOSURE,
    },
    orig: {
      ...BLANK_DISCLOSURE,
    },
    formMessages: [],
    changed: false,
  },
  history: {},
  filteredHistory: [],
  historyFilters: {
    keyword: '',
    vertical: '',
    admin: '',
  },
  historyFilterOptions: {
    vertical: [],
    admin: [],
  },
};
